module.exports = __webpack_public_path__ + "static/media/visa-mastercard-icon.16c97e5f.png";